import AddIcon from "@mui/icons-material/Add";
import { Box, Chip, MenuItem, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { setDialogType } from "../../../lib/slices/dialogTypeSlice";
import { setSelectedClient } from "../../../lib/slices/selectedClientSlice";
import { updateAppointmentById } from "../../../services/appointments";
import StatusConfirmation from "./ConfirmationDiloge";
import SelectPaymentDialog from "./SelectPaymentDialog";
import ServiceCard from "./ServiceCard";

function SelectedServices({ handleCloseDialog, data, handleFetchEvents }) {
  const { user, services, event } = data;

  const openDialogRef = useRef();

  const dispatch = useDispatch();

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const openConfirmationPopUp = useRef();
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const menuData = [
    { value: "Accepted", label: "Accepted" },
    { value: "Booked", label: "Booked" },
    { value: "Confirmed", label: "Confirmed" },
    { value: "Arrived", label: "Arrived" },
    { value: "Started", label: "Started" },
    { value: "Cancelled", label: "Cancelled" },
  ];

  const renderTotalDuration = () => {
    let totalDuration = 0;

    services?.forEach((item) => {
      totalDuration += item?.serviceData?.duration || 0;
    });

    const hours = Math.floor(totalDuration / 60);
    const minutes = totalDuration % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours} hr${hours > 1 ? "s" : ""} ${minutes} mins`;
    } else if (hours > 0) {
      return `${hours} hr${hours > 1 ? "s" : ""} 00 mins`;
    } else {
      return `${minutes} mins`;
    }
  };

  const renderTotalPrice = () => {
    let totalprice = 0;

    services?.forEach((item) => {
      totalprice += item?.serviceData?.price || 0;
    });

    return totalprice;
  };

  const handleSaveAppointment = () => {
    dispatch(setDialogType("service"));
    dispatch(setSelectedClient(null));
    handleCloseDialog();
  };

  const handleCheckoutAppointment = () => {
    openDialogRef.current.isVisible({});
  };

  const handleStatusChange = (e) => {
    openConfirmationPopUp.current.isVisible({
      ...event,
      status: e.target.value,
    });
  };

  const handleConfirm = async (data) => {
    try {
      setIsLoading(true);
      const responce = await updateAppointmentById(event?.appointmentId, {
        status: data?.status,
      });
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        handleCloseDialog();
        handleFetchEvents();
        setOpenConfirmation(false);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerror");

      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleConfirmAppointment = () => {
    let data = {
      status: "Completed",
    };
    handleConfirm(data);
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
      height={"100vh"}
      position={"relative"}
    >
      <Box
        overflow={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Stack
          padding={2}
          position={"absolute"}
          top={0}
          left={0}
          right={0}
          zIndex={999}
          bgcolor={"#ffffff"}
          direction={"row"}
          justifyContent={"space-between"}
        >
          <Box>
            <Typography
              variant="h1"
              fontSize={"1.225rem"}
              fontWeight={500}
              fontFamily={"Poppins"}
              color={"#40B6E9"}
            >
              {event?.status}
            </Typography>
            <Typography variant="body2" fontSize={"0.875rem"} fontWeight={300}>
              Source:
              <Typography
                component={"span"}
                color={"primary.main"}
                fontSize={"1rem"}
              >
                {event?.type}
              </Typography>
            </Typography>
          </Box>
          <Stack>
            <Typography variant="body2" color={"#A6A9AC"} fontSize={"0.75rem"}>
              {moment(event?.start).format("DD/MM/YYYY")}
            </Typography>
            <Typography variant="body2" color={"#A6A9AC"} fontSize={"0.75rem"}>
              {moment(event?.start).format("hh:mm a")}
            </Typography>
          </Stack>
        </Stack>
        <Box p={2} mt={"70px"}>
          {/* <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography variant="h6" fontWeight={600}>
              Services
            </Typography>
            <Chip
              icon={<AddIcon />}
              label="Add Service"
              variant="outlined"
              onClick={() => {
                dispatch(setDialogType("service"));
              }}
            />
          </Stack> */}
          <Box my={2}>
            {services?.map((val, ind) => {
              return (
                <React.Fragment key={ind}>
                  <ServiceCard
                    key={ind}
                    data={val}
                    showActions={true}
                    event={event}
                  />
                </React.Fragment>
              );
            })}
          </Box>

          <Label labelText="Status" required />
          <CustomDropDown
            size={"small"}
            value={event?.status}
            onChange={handleStatusChange}
          >
            {menuData?.map((item) => {
              return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
            })}
          </CustomDropDown>

          <Stack my={2}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Typography variant="body1" fontWeight={600}>
                Total Duration
              </Typography>

              <Typography variant="h6" fontWeight={600} fontSize={14}>
                {renderTotalDuration()}
              </Typography>
            </Stack>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Typography variant="body1" fontWeight={600}>
                Total Price
              </Typography>

              <Typography variant="h6" fontWeight={600} fontSize={14}>
                {renderTotalPrice()} SAR
              </Typography>
            </Stack>
          </Stack>
          <Stack direction={"row"} spacing={1}>
            <GlobalButton
              variant={"outlined"}
              btnText={"Check out"}
              handleClickBtn={handleCheckoutAppointment}
            />
          </Stack>
        </Box>
      </Box>
      <StatusConfirmation
        ref={openConfirmationPopUp}
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        handleConfirm={handleConfirm}
      />
      <SelectPaymentDialog
        ref={openDialogRef}
        handleConfirmAppointment={handleConfirmAppointment}
      />
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </Box>
  );
}

export default SelectedServices;
